import axios from "axios";
import { API_BASE_URL } from "./apiConstants";
import { getToken, removeToken } from "./auth";

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 100000000000,
  headers: {
    "Content-Type": "application/json",
  },
});

/* =========================
   Request Interceptor
========================= */
api.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {console.log(error,"Promise"); Promise.reject(error)}
);

/* =========================
   Response Interceptor
========================= */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Unauthorized
      if (error.response.status === 401) {
        removeToken();
        window.location.href = "/sign-in";
      }
    }
    console.log(error.response,"reject");
    return Promise.reject(error);
  }
);

export default api;
